import api from 'util/api';
import logger from 'util/logger';

export const submitOrganizationSignup = async (
  signupData,
  { setStateData, setStep, step, finalizeSignupSuccess }
) => {
  const {
    email,
    pwd,
    first_name,
    last_name,
    organization_name,
    organization_type,
    phone,
    SmsOptIn,
    address1,
    address2,
    address3,
    city,
    state,
    country,
    postal_code,
    localtimezone,
    leadSource,
    campaignId
  } = signupData;

  return api.Organization.signup({
    OrganizationName: organization_name,
    OrganizationType: organization_type,
    ContactPersonName: [first_name, last_name].filter(Boolean).join(' '),
    Email: email,
    PhoneNumber: phone || null,
    Password: pwd,
    Address1: address1,
    Address2: address2 || null,
    Address3: address3 || null,
    City: city,
    State: state,
    Province: null,
    Country: country,
    PostalCode: postal_code,
    LocalTimezone: localtimezone,
    LeadSource: leadSource,
    CampaignId: campaignId
  })
    .then(res => {
      if (res?.Success == false) {
        setStateData(stateData => ({
          ...stateData,
          creatingAccount: false,
          validationErr: [res.Text]
        }));
        return false;
      } else {
        finalizeSignupSuccess(res, email, SmsOptIn);
      }
    })
    .catch(err => {
      logger.log('organization signup error', err);
      setStep(step - 1);
      setStateData(stateData => ({
        ...stateData,
        creatingAccount: false,
        validationErr: [err.Text]
      }));
      return false;
    });
};

export const getOrganizationSignupValidationError = (step, getValue) => {
  const fields =
    step === 1
      ? [
          ['organization_name', 'Organization name required'],
          ['organization_type', 'Organization type required']
        ]
      : step === 2
      ? [['phone', 'Phone number required']]
      : [
          ['address1', 'Address line 1 required'],
          ['city', 'City required'],
          ['state', 'State required'],
          ['country', 'Country required'],
          ['postal_code', 'Postal code required'],
          ['localtimezone', 'Timezone required']
        ];
  return fields.find(([name]) => !getValue(name))?.[1] || null;
};
